import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as actions from './actions'

const initialState = Immutable.from({
  requestedPhoneNumber: {
    isFetching: false,
    error: '',
    phoneNumber: '',
    adId: '',
  },
})

const phoneNumber = (state = initialState, { type, payload, error, meta: adId }) => {
  let newState
  switch (type) {
    case actions.REQUEST_VIEW_PHONE_NUMBER:
      return state.set('requestedPhoneNumber', {
        ...state.requestedPhoneNumber,
        isFetching: true,
        phoneNumber: '',
        phoneNumberItu: '',
        adId: '',
        error: '',
        errorStatus: '',
      })
    case actions.RECEIVE_VIEW_PHONE_NUMBER:
      if (error) {
        newState = state.set('requestedPhoneNumber', {
          ...state.requestedPhoneNumber,
          isFetching: false,
          phoneNumber: '',
          phoneNumberItu: '',
          adId,
          // If the user has an ad blocker, we won't have a `textOrJson` object on the payload
          error: _.get(payload, ['textOrJson', 'errorTranslated']),
          errorStatus: _.get(payload, ['textOrJson', 'error']),
        })
      } else {
        newState = state.set('requestedPhoneNumber', {
          ...state.requestedPhoneNumber,
          isFetching: false,
          phoneNumber: payload.phoneNumber,
          phoneNumberItu: payload.phoneNumberItu,
          adId,
          error: '',
          errorStatus: '',
        })
      }
      return newState
    default:
      return state
  }
}

export default phoneNumber
